export class SchedulerConfigValueObject {
  static defaultView       = 'defaultView'
  static minTime           = 'minTime'
  static maxTime           = 'maxTime'
  static schedulerCalRec   = 'SchedulerCalRec'
  static refreshEventsData = 'RefreshEventsData'

  /**
   *
   * @param defaultView
   * @param minTime
   * @param maxTime
   * @param schedulerCalRec
   * @param refreshEventsData
   */
  constructor (
    defaultView,
    minTime,
    maxTime,
    schedulerCalRec,
    refreshEventsData
  ) {
    this._defaultView       = defaultView
    this._minTime           = minTime
    this._maxTime           = maxTime
    this._schedulerCalRec   = schedulerCalRec
    this._refreshEventsData = refreshEventsData
  }

  get maxTime () {
    return this._maxTime
  }

  get minTime () {
    return this._minTime
  }

  get defaultView () {
    /** @TODO: this is must be deleted **/
    if (this._defaultView === 'resourceTimeLineWorkWeek') {
      return 'resourceTimelineWeek'
    }

    return this._defaultView
  }

  get schedulerCalRec () {
    return this._schedulerCalRec
  }

  get refreshEventsData () {
    return this._refreshEventsData
  }

  /**
   *
   * @param apiObject
   * @returns {SchedulerConfigValueObject}
   */
  static fromApiObject (apiObject) {
    return new SchedulerConfigValueObject(
      apiObject[SchedulerConfigValueObject.defaultView],
      apiObject[SchedulerConfigValueObject.minTime],
      apiObject[SchedulerConfigValueObject.maxTime],
      apiObject[SchedulerConfigValueObject.schedulerCalRec],
      parseInt(apiObject[SchedulerConfigValueObject.refreshEventsData]) * 1000
    )
  }
}
